import { render, staticRenderFns } from "./Information.vue?vue&type=template&id=1a8ce12e&"
import script from "./Information.vue?vue&type=script&lang=js&"
export * from "./Information.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports